export default __webpack_public_path__ + "static/a55f66a5-117b-4425-8117-26ce611e310a-92b40326a4fce87aca37fe2e8abc9f4f.jpg";